import Subheader from 'material-ui/Subheader';
import PropTypes from 'prop-types';
import r from 'render-dom';

import { alternateTextColor, primary1Color } from 'constants/colors';

const Header = ({
    buttons = null,
    icon,
    navTitle,
    title,
}) => {
    const style = {
        buttons: {
            paddingTop: 18,
            textAlign: 'right'
        },
        buttonsCol: {
            boxSizing: 'border-box',
            float: 'left',
            position: 'relative',
            width: '30%',
        },
        header: {
            backgroundColor: primary1Color,
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.23)',
            height: 134,
            width: '100%',
            zIndex: 999,
        },
        section: {
            bottom: navTitle ? 50 : 0,
            lineHeight: 'normal',
            padding: '0 35px',
            position: 'absolute',
        },
        title: {
            color: alternateTextColor,
            fontSize: 24,
            fontWeight: 500,
            height: 72,
            lineHeight: '72px',
        },
        titleCol: {
            boxSizing: 'border-box',
            float: 'left',
            position: 'relative',
            width: '70%',
        },
    };

    return (
        r.div({ style: style.header }, [
            r(Subheader, { style: style.section }, [
                r.div({ style: { ...style.titleCol, ...style.title } }, [
                    icon,
                    r.span([title]),
                ]),
                r.div({ style: style.buttonsCol }, [
                    r.div({ style: style.buttons }, [
                        buttons,
                    ]),
                ]),
            ]),
        ])
    );
};

Header.propTypes = {
    buttons: PropTypes.node,
    headerStyle: PropTypes.object,
    navTitle: PropTypes.node,
    title: PropTypes.string.isRequired,
    titleStyle: PropTypes.object,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/shared/Header/index.js